import { typographyStyle, Flex } from '@revenuemarket/cds';
import { Breadcrumb } from 'antd';

interface Props {
  breadcrumbItems?: { key: string; title: string }[];
  treeSelectSection: React.ReactNode;
}

const MigrationListItem: React.FC<Props> = ({ breadcrumbItems, treeSelectSection }) => {
  return (
    <Flex justify="space-between" align="center">
      <div
        style={{
          flex: 1,
        }}
      >
        <Breadcrumb
          items={breadcrumbItems}
          style={{
            width: 'max-content',

            ...typographyStyle['14_400'],
          }}
        />
      </div>
      {treeSelectSection}
    </Flex>
  );
};

export default MigrationListItem;
